<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>Para nos conhecermos melhor, nos informe o seu site e as redes socias da sua empresa:</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group">
            <label for="Site">Site</label>
            <input type="text" class="form-control form-control-lg" v-model="Site" placeholder="Ex: iouu.com.br">
          </div>
          <div class="form-group">
            <label for="logradouro">Facebook</label>
            <input type="text" class="form-control form-control-lg" v-model="Facebook" placeholder="Ex: www.facebook.com/IouuBrasil/">
          </div>
          <div class="form-group">
            <label for="logradouro">Linkedin</label>
            <input type="text" class="form-control form-control-lg" v-model="Linkedin" placeholder="Ex: www.linkedin.com/company/iouu/">
          </div>
          <div class="text-center fixedOptions">
            <button v-focus class="btn btn-lg btn-primary">Próximo</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
 export default {
   data() {
     const Empresa = this.solicitacao.Empresa || {}
     return {
       Site: Empresa ?  Empresa.Site : null,
       Facebook: Empresa ? Empresa.Facebook: null,
       Linkedin: Empresa ? Empresa.Linkedin: null,
     }
   },
   props: {
     solicitacao: {required: true, type: Object}
   },
   methods: {
     onSubmit(e) {
       e.preventDefault()
       this.$emit('on-submit', {
         Empresa: {
             Site: this.Site,
             Facebook: this.Facebook,
             Linkedin: this.Linkedin,
         }
       })
     }
   }
 }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/SocialMediaStep.vue